export const DISCOUNT_APPLIED = 0.5;
export const DISCOUNTED_PRODUCT_KEYS = ['fivem'];
export const DISCOUNTED_PERCENTAGE_TEXT = `${Number(DISCOUNT_APPLIED * 100)}% OFF`;
